import omit from 'lodash.omit';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import { isIE, isMobileIos } from 'lib/getCustomerProperties';
import overrideStyle from 'lib/overrideStyle';
import styles from 'presentation/components/styles/InputBox.css';
let cx = classnames.bind(styles);

class InputBox extends React.Component {
  constructor(props) {
    super(props);

    this.textAreaRef = React.createRef();
    this.focus = this.focus.bind(this);
    this.addTouchHandler = this.addTouchHandler.bind(this);
    this.removeTouchHandler = this.removeTouchHandler.bind(this);
    this.handleInputScroll = this.handleInputScroll.bind(this);
  }

  componentDidMount() {
    isMobileIos() ? this.addTouchHandler() : null;
  }

  componentWillUnmount() {
    isMobileIos() ? this.removeTouchHandler() : null;
  }

  focus() {
    this.textAreaRef.current && this.textAreaRef.current.focus();

    // Must do the following for IE browsers, otherwise customer won't be able to type when the composition is initially focused
    if (isIE()) {
      setTimeout(() => {
        document.activeElement.blur();
        this.textAreaRef.current && this.textAreaRef.current.focus();
      }, 5);
    }
  }

  addTouchHandler() {
    this.textAreaRef.current && this.textAreaRef.current.addEventListener('touchmove', this.handleInputScroll);
  }

  removeTouchHandler() {
    this.textAreaRef.current && this.textAreaRef.current.removeEventListener('touchmove', this.handleInputScroll);
  }

  handleInputScroll(ev) {
    let textArea = this.textAreaRef.current;
    let isInputScrollable = textArea.scrollHeight > textArea.clientHeight;
    if (textArea.contains(ev.target) && isInputScrollable) {
      /* We only want to allow scrolling behavior when the input is scrollable. Skipping this check makes the Sidekick scrollable when the text area is scrolled  */
      return;
    }
    ev.preventDefault();
  }

  render() {
    let renderProps = omit(this.props, ['className', 'onChange', 'prompt']);
    return (
      <div
        className={cx(
          styles.inputBox,
          this.props.className,
          this.props.hasAttachments ? styles.inputBox_withAttachments : '',
          this.props.attachmentsEnabled ? styles.inputBox_attachments_enabled : ''
        )}
      >
        <TextArea
          id={'gladlyTextBox'}
          className={cx(
            styles.inputBox_textarea,
            'inputBox_textArea',
            this.props.attachmentsEnabled
              ? styles.inputBox_textarea_attachment_button_spacing
              : styles.inputBox_textarea_send_button_spacing
          )}
          maxLength={1000}
          onChange={this.props.onChange}
          onKeyDown={this.props.onKeyDown}
          placeholder={this.props.prompt}
          value={this.props.value}
          ref={this.textAreaRef}
          {...renderProps}
        />
      </div>
    );
  }
}

export default InputBox;

InputBox.propTypes = {
  prompt: PropTypes.string.isRequired,
  value: PropTypes.string,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func.isRequired,
};

const TextArea = overrideStyle('textarea')`
  font-family: ${p => p.theme.fontLibrary.secondary};
  &::placeholder {
    overflow: hidden;
  }
`;
